import { useEffect, useState } from "react";
import { Outlet, useMatch } from "react-router-dom";

import { Footer } from "./footer";
import { Header } from "./header";
import { SideBar } from "./side-bar";
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "../ui/Dialog";
import { useTranslation } from "~/i18n";

export function AppLayout() {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const surveyDetailMatch = useMatch("/surveys/:uuid/*");
  const surveyUuid = surveyDetailMatch?.params.uuid;

  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 1024px)");
    const closeOnDesktop = (event: MediaQueryListEvent) => {
      if (event.matches) closeSidebar();
    };

    desktop.addEventListener("change", closeOnDesktop);
    return () => desktop.removeEventListener("change", closeOnDesktop);
  }, []);

  return (
    <>
      <Dialog open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <Header sidebarOpen={sidebarOpen} />
        <DialogPortal>
          <DialogOverlay className="fixed inset-0 z-30 bg-black/50 data-[state=closed]:animate-[drawer-overlay-out_300ms_ease-in] data-[state=open]:animate-[drawer-overlay-in_300ms_ease-out] motion-reduce:animate-none lg:hidden" />
          <DialogContent
            aria-describedby={undefined}
            className="fixed inset-y-0 left-0 z-40 h-screen w-4/5 max-w-3xs outline-none data-[state=closed]:animate-[drawer-out_300ms_ease-in] data-[state=open]:animate-[drawer-in_300ms_ease-out] motion-reduce:animate-none lg:hidden"
          >
            <DialogTitle className="sr-only">
              {t("navigation.drawer.openMenu")}
            </DialogTitle>
            <SideBar onClose={closeSidebar} surveyUuid={surveyUuid} />
          </DialogContent>
        </DialogPortal>
      </Dialog>

      <SideBar
        className="fixed inset-y-0 left-0 z-40 hidden w-[369px] shadow-navigation lg:block"
        surveyUuid={surveyUuid}
      />

      <div className="flex min-h-screen min-w-0 flex-col pt-14 lg:ml-[369px] lg:pt-0">
        <div className="m-4 min-w-0 flex-1 lg:pt-0">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  );
}
